import React, { useEffect, useState } from "react"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import FormValidator from "../../../../utils/FormValidator"
import isNull from "../../../../utils/NullChecking"
import { ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest"
import Loader from "../../../shared/Loader/Loader"
import { MenuItem, Select } from "@mui/material"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Modal from 'react-bootstrap/Modal';
import { ClaimType, ConnectivityType, EDIVersion, ExportFormat, ISA01, ISA03, ISA05, ISA07, ISA15, Type } from "../../../../utils/Constants";
import ModalFooter from "../../Shared/ModalFooter";
import handleNumericCheck from "../../../../utils/HandleNumericKeys";
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler'
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns";
import { useSelector } from "react-redux";
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import { FindSecondChild } from "../../../../utils/FindMenuOption";
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber";
import { Email } from "@mui/icons-material";
const AddNewSubmitter = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Submitter/Receiver ')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Insurance', 'Submitter/Receiver ')?.IsDeleted
    const API_URL = enumUtil.controller.General
    const API_URL_Down = enumUtil.controller.EDI
    const { IsOpenSubmitter, onClose, onDeleteSubmitter, type } = { ...props }
    const [del, setDel] = useState(false)
    const [expanded, setExpanded] = React.useState(false);
    const handleChangeAccordian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const [isOpenAudit, setisOpenAudit] = useState(false);
    let Submitter_Modal = {
        ProfileName: "",
        UpdatedDate: "",
        UpdatedBy: "",
        ReceiverName: "",
        ReceiverID: "",
        ExportFormat: "",
        EDIVersion: "",
        ClaimType: "",
        Segment: "~",
        Element: "*",
        Component: ":",
        Repetition: "^",
        Notes: "",
        ConnectivityType: "",
        SFTPHost: "",
        ConnectivityStatus: "",
        SFTPUserName: "",
        SFTPPassword: "",
        SFTPPort: "",
        UploadDirectory: "",
        ReportsDirectory: "",
        ErasDirectory: "",
        FileName: "",
        DeleteAfterDownload: false,
        AutoClaimSubmission: false,
        AutoReportsDownload: false,
        Type: "",
        BusinessName: "",
        FirstName: "",
        SubmitterID: "",
        ContactName: "",
        PhoneNumber: "",
        Email: "",
        ISA01: "",
        ISA02: "",
        ISA03: "",
        ISA04: "",
        ISA05: "",
        ISA06: "",
        ISA07: "",
        ISA08: "",
        ISA15: "",
        GS02: "",
        GS03: "",
        AcknowledgeRequested: false,
        Active: true

    }

    let valModal = {}
    // validation modal 
    let ValidationModal = {
        ProfileName: "",
        ReceiverName: "",
        ReceiverID: "",
        ExportFormat: "",
        EDIVersion: "",
        ClaimType: "",
        Segment: "",
        Element: "",
        Component: "",
        Repetition: "",
        BusinessName: "",
        ISA01ValReq: "",
        // ISA02ValReq: "",
        ISA03ValReq: "",
        // ISA04ValReq: "",
        ISA05ValReq: "",
        ISA06ValReq: "",
        ISA07ValReq: "",
        ISA08ValReq: "",
        ISA15ValReq: "",
        GS02ValReq: "",
        GS03ValReq: "",
        ISA02Val: "",
        ISA04Val: "",
        // ISA06Val: "",
        ISA08Val: "",
        GS02Val: "",
        GS03Val: "",
        TypeVal: "",
        Type: "",
        BusinessNameval: '',
        SubmitterIDVal: '',
        PhoneNumberVal: "",
        ContactNameval: "",
        PhoneNumberLenghtVal: "",
        EmailVal: "",

    }
    const [mainSubmitterModal, setmainSubmitterModal] = useState(Submitter_Modal);
    const [SubmitterSaveUpdateModal, setSubmitterSaveUpdateModal] = useState({})
    const [practiceValidationModal, setPracticeValidationModal] = useState(ValidationModal)
    const [SubmitterID, setSubmitterID] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [onSubmitterSave, setOnSubmitterSave] = useState(false);
    const [is, setIs] = useState(false);

    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)


    // find practice Data by id 
    useEffect(() => {

        if (props.SubmitterID != null) {
            setSubmitterID(props.SubmitterID)
            setDel(true)
        } else {
            if (!onSubmitterSave) {
                setSubmitterID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
    }, [])
    useEffect(() => {
        if (!isNull(SubmitterID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": SubmitterID,
                "TableName": enumUtil.enumAPITableName.SubmitterReceiver
            }).then((response) => {
                response.Type = DropdownValueHandler(Type, response.Type);
                response.ISA01 = DropdownValueHandler(ISA01, response.ISA01);
                response.ISA03 = DropdownValueHandler(ISA03, response.ISA03);
                response.ISA05 = DropdownValueHandler(ISA05, response.ISA05);
                response.ISA07 = DropdownValueHandler(ISA07, response.ISA07);
                response.ISA15 = DropdownValueHandler(ISA15, response.ISA15);
                response.ClaimType = DropdownValueHandler(ClaimType, response.ClaimType);
                if (!isNull(response.PhoneNumber)) {
                    response.PhoneNumber = FormatPhoneNumber(response.PhoneNumber)
                }
                response.ConnectivityType = DropdownValueHandler(ConnectivityType, response.ConnectivityType);
                response.EDIVersion = DropdownValueHandler(EDIVersion, response.EDIVersion);
                response.ExportFormat = DropdownValueHandler(ExportFormat, response.ExportFormat);
                setIsLoading(false)
                setIs(true);
                setmainSubmitterModal(response)

            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
    }, [SubmitterID])
    const handleSubmitterCreditonalChange = (e) => {
        let { name, value } = e.target;

        let modal = { ...mainSubmitterModal };
        let saveModal = { ...SubmitterSaveUpdateModal }
        modal[name] = value
        setmainSubmitterModal(modal)
        for (var property in Submitter_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSubmitterSaveUpdateModal(saveModal)
    }
    // handle change for Practice 
    const handleSubmitterChange = (e) => {

        let { name, value, checked } = e.target;
        console.log(name, value, 'sdsadsada');

        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }

        let modal = { ...mainSubmitterModal };
        let saveModal = { ...SubmitterSaveUpdateModal }
        if (name === 'PhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === "Active") {
            modal[name] = checked;
        }
        else if (name === "AcknowledgeRequested" || name === 'DeleteAfterDownload' || name === 'AutoReportsDownload' || name === 'AutoClaimSubmission') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainSubmitterModal(modal)
        for (var property in Submitter_Modal) {
            if (name === property) {
                if (name === "AcknowledgeRequested" || name === 'DeleteAfterDownload' || name === 'AutoReportsDownload' || name === 'AutoClaimSubmission' || name === "Active") {
                    saveModal[name] = modal[name] + ""
                }

                else {
                    saveModal[name] = value
                }
            }
        }
        setSubmitterSaveUpdateModal(saveModal)
        console.log(saveModal, 'saveModal');
        // PracticeValidation();
    }


    const handleSelectedData = (selectedData, name, type) => {

        let modal = { ...mainSubmitterModal };
        if (type === 'client' && !isNull(selectedData)) {
            console.log(selectedData, name, type);
            if (name === 'ExportFormat') {
                modal[name] = selectedData.display
                SubmitterSaveUpdateModal[name] = selectedData.code + "";
                SubmitterSaveUpdateModal['ExportFormat'] = selectedData.value + "";
            }
            else {
                modal[name] = selectedData.display
                SubmitterSaveUpdateModal[name] = selectedData.value;
            }

        }
        else {
            modal[name] = ''
            SubmitterSaveUpdateModal[name] = ''
        }
        setmainSubmitterModal(modal)

        return selectedData
    }
    const PracticeValidation = async () => {
        let ContactNumber = '';
        if (!isNull(mainSubmitterModal.PhoneNumber)) {
            ContactNumber = mainSubmitterModal.PhoneNumber.replace(/[()-\s]/g, '');
        }
        let ValidationModal = {
            PracticeCodeVal: FormValidator(
                mainSubmitterModal.ProfileName,
                enumUtil.enumValidationType.Required,
                'Profile Name',
            ),
            TypeVal: FormValidator(
                mainSubmitterModal.Type,
                enumUtil.enumValidationType.Required,
                'Type',
            ),
            BusinessNameval: FormValidator(
                mainSubmitterModal.BusinessName,
                enumUtil.enumValidationType.Required,
                'Business Name',
            ),
            SubmitterIDVal: FormValidator(
                mainSubmitterModal.SubmitterID,
                enumUtil.enumValidationType.Required,
                'Submitter ',
            ),
            PhoneNumberVal: FormValidator(
                mainSubmitterModal.PhoneNumber,
                enumUtil.enumValidationType.Required,
                'Phone Number',
            ),
            ContactNameval: FormValidator(
                mainSubmitterModal.ContactName,
                enumUtil.enumValidationType.Required,
                'Contact Name',
            ),
            PhoneNumberLenghtVal: FormValidator(
                ContactNumber,
                enumUtil.enumValidationType.Length,
                'Phone Number',
                10
            ),
            EmailVal: FormValidator(
                mainSubmitterModal.Email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            // ISA02Val: FormValidator(
            //     mainSubmitterModal.ISA02,
            //     enumUtil.enumValidationType.Length,
            //     'ISA 02 ',
            //     10
            // ),
            // ISA04Val: FormValidator(
            //     mainSubmitterModal.ISA04,
            //     enumUtil.enumValidationType.Length,
            //     'ISA 04 ',
            //     10
            // ),
            // ISA06Val: FormValidator(
            //     mainSubmitterModal.ISA06,
            //     enumUtil.enumValidationType.Length,
            //     'ISA 06 ',
            //     15
            // ),
            // ISA08Val: FormValidator(
            //     mainSubmitterModal.ISA08,
            //     enumUtil.enumValidationType.Length,
            //     'ISA 08 ',
            //     15
            // ),
            // GS02Val: FormValidator(
            //     mainSubmitterModal.GS02,
            //     enumUtil.enumValidationType.Lengths,
            //     'GS02 ',
            //     2, 15
            // ),
            // GS03Val: FormValidator(
            //     mainSubmitterModal.GS03,
            //     enumUtil.enumValidationType.Lengths,
            //     'GS03 ',
            //     2, 15
            // ),
            ISA01ValReq: FormValidator(
                mainSubmitterModal.ISA01,
                enumUtil.enumValidationType.Required,
                'ISA 01 ',
            ),
            // ISA02ValReq: FormValidator(
            //     mainSubmitterModal.ISA02,
            //     enumUtil.enumValidationType.Required,
            //     'ISA 02 ',
            // ),
            ISA03ValReq: FormValidator(
                mainSubmitterModal.ISA03,
                enumUtil.enumValidationType.Required,
                'ISA 03 ',
            ),
            // ISA04ValReq: FormValidator(
            //     mainSubmitterModal.ISA04,
            //     enumUtil.enumValidationType.Required,
            //     'ISA 04 ',
            // ),
            ISA05ValReq: FormValidator(
                mainSubmitterModal.ISA05,
                enumUtil.enumValidationType.Required,
                'ISA 05 ',
            ),
            ISA06ValReq: FormValidator(
                mainSubmitterModal.ISA06,
                enumUtil.enumValidationType.Required,
                'ISA 06 ',
            ),
            ISA07ValReq: FormValidator(
                mainSubmitterModal.ISA07,
                enumUtil.enumValidationType.Required,
                'ISA 07 ',
            ),
            ISA08ValReq: FormValidator(
                mainSubmitterModal.ISA08,
                enumUtil.enumValidationType.Required,
                'ISA 08 ',
            ),
            ISA15ValReq: FormValidator(
                mainSubmitterModal.ISA15,
                enumUtil.enumValidationType.Required,
                'ISA 15 ',
            ),
            GS02ValReq: FormValidator(
                mainSubmitterModal.GS02,
                enumUtil.enumValidationType.Required,
                'GS02 ',
            ),
            GS03ValReq: FormValidator(
                mainSubmitterModal.GS03,
                enumUtil.enumValidationType.Required,
                'GS03 ',
            ),

        }
        await setPracticeValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    // save practice button click 
    const handleSaveSubmitter = async () => {
        await PracticeValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        }
        else {
            if (!isNull(SubmitterSaveUpdateModal.PhoneNumber)) {
                SubmitterSaveUpdateModal['PhoneNumber'] = SubmitterSaveUpdateModal.PhoneNumber.replace(/[()-\s]/g, "");
                SubmitterSaveUpdateModal.PhoneNumber = SubmitterSaveUpdateModal.PhoneNumber.slice(0, 10);
            }
            let saveData = { ...SubmitterSaveUpdateModal };
            if (isNull(saveData.Segment) || saveData.Segment === undefined) {
                saveData.Segment = mainSubmitterModal.Segment;
            }
            // Element check
            if (isNull(saveData.Element) || saveData.Element === undefined) {
                saveData.Element = mainSubmitterModal.Element;
            }
            if (isNull(saveData.Component) || saveData.Component === undefined) {
                saveData.Component = mainSubmitterModal.Component;
            }
            if (isNull(saveData.Repetition) || saveData.Repetition === undefined) {
                saveData.Repetition = mainSubmitterModal.Repetition;
            }

            // ConnectivityStatus as before
            saveData.ConnectivityStatus = isNull(mainSubmitterModal.ConnectivityStatus) ? 'false' : mainSubmitterModal.ConnectivityStatus;
            let saveModal = {
                TableName: enumUtil.enumAPITableName.SubmitterReceiver,
                ID: SubmitterID,
                data: { ...saveData },
                // data: { ...SubmitterSaveUpdateModal, ConnectivityStatus: isNull(mainSubmitterModal.ConnectivityStatus) ? 'false' : mainSubmitterModal.ConnectivityStatus },
                value: null
            }
            // console.log(SubmitterSaveUpdateModal,'SubmitterSaveUpdateModal');

            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal).then((response) => {
                setIsLoading(false)
                if (!isNull(response.id)) {
                    UpdateReduxDropDowns(SubmitterID, DropDowns.Receiver, response.id, mainSubmitterModal.ProfileName)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    setSubmitterID(response.id)
                    setOnSubmitterSave(true)
                    onDeleteSubmitter()

                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleCheckConnectivity = () => {
        setIsLoading(true);
        ServerRequestProtected(API_URL_Down + "/TestSFTPConnection", 'post', {
            SFTPHost: mainSubmitterModal.SFTPHost + "",
            SFTPUserName: mainSubmitterModal.SFTPUserName + "",
            SFTPPassword: mainSubmitterModal.SFTPPassword + "",
            SFTPPort: mainSubmitterModal.SFTPPort + "",
            ConnectivityType: mainSubmitterModal.ConnectivityType + "",
        })
            .then((response) => {
                setIsLoading(false);
                // NotificationHandler('SFTP connection successful!', enumUtil.enumtoaster.success)
                mainSubmitterModal.ConnectivityStatus = 'true'
            })
            .catch((error) => {
                setIsLoading(false);
                mainSubmitterModal.ConnectivityStatus = 'false'
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            });
    };
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} TableName={enumUtil.enumAPITableName.SubmitterReceiver} ID={SubmitterID} onClose={onDeleteSubmitter} API_URL={API_URL} dropDown={DropDowns.Receiver} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={SubmitterID + ""} TableName={enumUtil.enumAPITableName.SubmitterReceiver} />
    }
    const SetSubmitterName = () => {
        if (mainSubmitterModal.ProfileName != null && mainSubmitterModal.ProfileName != "") {
            return (
                <p className="heading sm">{mainSubmitterModal.ProfileName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add Submitter/Receiver</p>
            )
        }
    }
    const AddNewSubmitterModalBody = () => {
        return (
            <div className="row g-0 h-100">
                <div className="col-md-4 br-clr br-right-1">
                    <div className="pe-3">
                        <div className="from-group input">
                            <label htmlFor="">Profile Name<span className='req'>*</span></label>
                            <div className={practiceValidationModal.PracticeCodeVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="ProfileName"
                                    id="ProfileName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={mainSubmitterModal.ProfileName}
                                    onChange={handleSubmitterChange} />
                                {practiceValidationModal.PracticeCodeVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Receiver Name<span className='req'>*</span></label>
                            <div className={practiceValidationModal.ReceiverNameCodeVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="ReceiverName"
                                    id="ReceiverName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={mainSubmitterModal.ReceiverName}
                                    onChange={handleSubmitterChange}
                                />
                                {practiceValidationModal.ReceiverNameCodeVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Receiver ID<span className='req'>*</span></label>
                            <div className={practiceValidationModal.ReceiverIDCodeVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="ReceiverID"
                                    id="ReceiverID"
                                    autoComplete="off"
                                    value={mainSubmitterModal.ReceiverID}
                                    onChange={handleSubmitterChange}
                                />
                                {practiceValidationModal.ReceiverIDCodeVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Export Format<span className='req'>*</span></label>
                            <div className={practiceValidationModal.ExportFormatCodeVal ? 'form-group input error' : 'input form-group '}>
                                <SuperSearchList
                                    type="client"
                                    id='ExportFormat'
                                    name='ExportFormat'
                                    searchValue={mainSubmitterModal.ExportFormat}
                                    data={ExportFormat}
                                    onChange={handleSubmitterChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    inputError={practiceValidationModal.ExportFormatCodeVal}
                                />
                                {practiceValidationModal.ExportFormatCodeVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">EDI Version<span className='req'>*</span></label>
                            <div className={practiceValidationModal.EDIVersiontCodeVal ? 'form-group input error' : 'input form-group '}>
                                <SuperSearchList
                                    type="client"
                                    id='EDIVersion'
                                    name='EDIVersion'
                                    searchValue={mainSubmitterModal.EDIVersion}
                                    data={EDIVersion}
                                    onChange={handleSubmitterChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    inputError={practiceValidationModal.EDIVersiontCodeVal}
                                />

                                {practiceValidationModal.EDIVersiontCodeVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Claim Type<span className='req'>*</span></label>
                            <div className={practiceValidationModal.ClaimTypeCodeVal ? 'form-group input error' : 'input form-group '}>
                                <SuperSearchList
                                    type="client"
                                    id='ClaimType'
                                    name='ClaimType'
                                    searchValue={mainSubmitterModal.ClaimType}
                                    data={ClaimType}
                                    onChange={handleSubmitterChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    inputError={practiceValidationModal.ClaimTypeCodeVal}

                                />
                                {practiceValidationModal.ClaimTypeCodeVal}
                            </div>
                        </div>
                        <div className="row row-half">
                            <span className="heading ps-2"> Separator:</span>
                            <div className='col-md-3'>
                                <div className={practiceValidationModal.SegmentCodeVal ? 'form-group input error' : 'input form-group '}>
                                    <label htmlFor="" className="xsm_text">Segment<span className='req'>*</span></label>
                                    <input type="text"
                                        className='form-control'
                                        name="Segment"
                                        id="Segment"
                                        autoComplete="off"
                                        maxLength={1}
                                        value={mainSubmitterModal.Segment}
                                        onChange={handleSubmitterChange}
                                    />
                                    {practiceValidationModal.SegmentCodeVal}
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className={practiceValidationModal.ElementCodeVal ? 'form-group input error' : 'input form-group '}>
                                    <label htmlFor="" className="xsm_text">Element<span className='req'>*</span></label>
                                    <input type="text"
                                        className='form-control'
                                        name="Element"
                                        id="Element"
                                        maxLength={1}
                                        value={mainSubmitterModal.Element}
                                        onChange={handleSubmitterChange}
                                    />
                                    {practiceValidationModal.ElementCodeVal}
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className={practiceValidationModal.ComponentCodeVal ? 'form-group input error' : 'input form-group '}>
                                    <label htmlFor="" className="xsm_text">Component<span className='req'>*</span></label>
                                    <input type="text"
                                        className='form-control'
                                        name="Component"
                                        id="Component"
                                        autoComplete="off"
                                        maxLength={1}
                                        value={mainSubmitterModal.Component}
                                        onChange={handleSubmitterChange}
                                    />
                                    {practiceValidationModal.ComponentCodeVal}
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className={practiceValidationModal.RepetitionCodeVal ? 'form-group input error' : 'input form-group '}>
                                    <label htmlFor="" className="xsm_text">Repetition<span className='req'>*</span></label>
                                    <input type="text"
                                        className='form-control'
                                        name="Repetition"
                                        id="Repetition"
                                        autoComplete="off"
                                        maxLength={1}
                                        value={mainSubmitterModal.Repetition}
                                        onChange={handleSubmitterChange}
                                    />
                                    {practiceValidationModal.RepetitionCodeVal}
                                </div>
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Notes</label>
                            <textarea rows="4"
                                className='form-control'
                                name="Notes"
                                id="Notes"
                                autoComplete="off"
                                value={mainSubmitterModal.Notes}
                                onChange={handleSubmitterChange}
                            ></textarea>
                        </div>
                        <div>
                            {/* <div className='input custom_check_box del_download'>
                                <label className="d-flex align-items-center gap-3">
                                    <div className="form-check form-switch m-0 p-0">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="Active"
                                            name="Active"
                                            checked={mainSubmitterModal.Active}
                                            onChange={handleSubmitterChange}
                                        />
                                    </div>
                                    <p className="heading fs-12 lh-12 m-0">Active</p>
                                </label>
                            </div> */}
                            <div className='d-flex gap-1 align-items-center m-0 ar-toggle'>
                                <p className='fs-11 text font-m lh-11'>Active</p>
                                <div class="pe-0 m-0 insurance_radio_btn">
                                    <div class="form-check form-switch radio_button mh-unset m-0">
                                        <input
                                            class="form-check-input m-0"
                                            type="checkbox"
                                            id="mySwitch"
                                            name="Active"
                                            // checked={item?.IsActive}
                                            checked={mainSubmitterModal.Active === true}
                                            onChange={e => handleSubmitterChange(e)}
                                        // onChange={e => handleIsActiveChange(e.target.checked, item.RecordID)}

                                        // defaultChecked onClick={() => handleIsActiveChange(item.RecordID)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-8">
                    <div className="app-accordian">
                        <Accordion defaultExpanded>
                            {/* // expanded={expanded === 'submitterinformation'} onChange={handleChangeAccordian('submitterinformation')}> */}
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <p className="heading">Credentails</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-half hk-form-fields'>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Connectivity Type</label>
                                            <SuperSearchList
                                                type="client"
                                                id='ConnectivityType'
                                                name='ConnectivityType'
                                                searchValue={mainSubmitterModal.ConnectivityType}
                                                data={ConnectivityType}
                                                onChange={handleSubmitterChange}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Host</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SFTPHost"
                                                id="SFTPHost"
                                                autoComplete="off"
                                                value={mainSubmitterModal.SFTPHost}
                                                onChange={handleSubmitterCreditonalChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >User Name</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SFTPUserName"
                                                id="SFTPUserName"
                                                autoComplete="off"
                                                value={mainSubmitterModal.SFTPUserName}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Password</label>
                                            <input type="password"
                                                className='form-control'
                                                name="SFTPPassword"
                                                id="SFTPPassword"
                                                autoComplete="new-password"
                                                value={mainSubmitterModal.SFTPPassword}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Port</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SFTPPort"
                                                id="SFTPPort"
                                                autoComplete="off"
                                                maxLength={4}
                                                value={mainSubmitterModal.SFTPPort}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Claims Directory </label>
                                            <input type="text"
                                                className='form-control'
                                                name="UploadDirectory"
                                                id="UploadDirectory"
                                                autoComplete="off"
                                                value={mainSubmitterModal.UploadDirectory}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Report Directory </label>
                                            <input type="text"
                                                className='form-control'
                                                name="ReportsDirectory"
                                                id="ReportsDirectory"
                                                autoComplete="off"
                                                value={mainSubmitterModal.ReportsDirectory}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Eras Directory </label>
                                            <input type="text"
                                                className='form-control'
                                                name="ErasDirectory"
                                                id="ErasDirectory"
                                                autoComplete="off"
                                                value={mainSubmitterModal.ErasDirectory}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >File Name Pattern </label>
                                            <input type="text"
                                                className='form-control'
                                                name="FileName"
                                                id="FileName"
                                                autoComplete="off"
                                                value={mainSubmitterModal.FileName}
                                                onChange={handleSubmitterCreditonalChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6 hk-checkbox mt-2 ">
                                        <div className='input custom_check_box del_download align-items-center gap-2'>
                                            <input type="checkbox"
                                                className='form-check-input m-0 p-0'
                                                id="DeleteAfterDownload"
                                                name="DeleteAfterDownload"
                                                autoComplete="off"
                                                // value={mainSubmitterModal.DeleteAfterDownload}
                                                checked={mainSubmitterModal.DeleteAfterDownload}
                                                onChange={handleSubmitterChange}
                                            />
                                            <p className="heading fs-12">Delete After Download</p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 align-content-end">
                                        <button className="btn za-btn-checkconnect rounded-1 w-100 fs-10" onClick={handleCheckConnectivity}>Check Connectivity</button>
                                    </div>
                                    <div className="col-md-9 hk-checkbox mt-2 ">
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <div className='input custom_check_box del_download align-items-center gap-2 flex-row mb-0'>
                                                <input type="checkbox"
                                                    className='form-check-input m-0 p-0'
                                                    id="AutoClaimSubmission"
                                                    name="AutoClaimSubmission"
                                                    autoComplete="off"
                                                    checked={mainSubmitterModal.AutoClaimSubmission}
                                                    onChange={handleSubmitterChange}
                                                />
                                                <p className="text fs-11 text-nowrap">Auto Claim Submission</p>
                                            </div>
                                            <div className='input custom_check_box del_download align-items-center gap-2 flex-row'>
                                                <input type="checkbox"
                                                    className='form-check-input m-0 p-0'
                                                    id="AutoReportsDownload"
                                                    name="AutoReportsDownload"
                                                    autoComplete="off"
                                                    checked={mainSubmitterModal.AutoReportsDownload}
                                                    onChange={handleSubmitterChange}
                                                />
                                                <p className="text fs-11 text-nowrap">Auto Reports Download</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* when Connection Successfull */}
                                {mainSubmitterModal.ConnectivityStatus === 'true' ?
                                    <div className="d-flex mt-3">
                                        <div className="col-md-4 hk-checkbox mt-2">
                                            <div className=" d-flex gap-2">
                                                <div className='input custom_check_box del_download align-items-center gap-1 opacity-25'>
                                                    <input type="checkbox"
                                                        className='form-check-input m-0 p-0'
                                                        id="AutoClaimSubmission"
                                                        name="AutoClaimSubmission"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                                <p className="text fs-10">Auto Claim Submission</p>
                                            </div>

                                        </div>
                                        <div className="col-md-5 hk-checkbox mt-2">
                                            <div className="d-flex gap-2">
                                                <div className='input custom_check_box del_download align-items-center gap-1 opacity-25'>
                                                    <input type="checkbox"
                                                        className='form-check-input m-0 p-0'
                                                        id="AutoReportsDownloading"
                                                        name="AutoReportsDownloading"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                                <p className="text fs-10">Auto Reports Downloading</p>
                                            </div>

                                        </div>
                                        {/* <div className="col-md-4 align-content-end ps-4 za-connectivity">
                                        <div className="d-flex gap-1">
                                            <i className="icon-check"></i>
                                            <p className="heading fs-10 za-light-grenn"></p>
                                        </div>

                                    </div> */}
                                        <div className="col-md-3 align-content-end za-connectivity w-100">
                                            <div className=" ">
                                                <p className="heading fs-9 za-light-grenn"><i className="icon-check "></i> Connectivity Successful</p>
                                            </div>

                                        </div>
                                    </div>
                                    : null}
                                {/* when connectivity Failed  */}
                                {/* {mainSubmitterModal.ConnectivityStatus === 'false' ?
                                <div className="d-flex mt-3">
                                    <div className="col-md-4 hk-checkbox mt-2">
                                        <div className=" d-flex gap-2">
                                            <div className='input custom_check_box del_download align-items-center gap-1 opacity-25'>
                                                <input type="checkbox"
                                                    className='form-check-input m-0 p-0'
                                                    id="AutoClaimSubmission"
                                                    name="AutoClaimSubmission"
                                                    autoComplete="off"
                                                />
                                            </div>
                                            <p className="text fs-10">Auto Claim Submission</p>
                                        </div>

                                    </div>
                                    <div className="col-md-5 hk-checkbox mt-2">
                                        <div className="d-flex gap-2">
                                            <div className='input custom_check_box del_download align-items-center gap-1 opacity-25'>
                                                <input type="checkbox"
                                                    className='form-check-input m-0 p-0'
                                                    id="AutoReportsSubmission"
                                                    name="AutoReportsSubmission"
                                                    autoComplete="off"
                                                />
                                            </div>
                                            <p className="text fs-10">Auto Reports Downloading</p>
                                        </div>

                                    </div>
                                       
                                            <div className="col-md-3 align-content-end za-connectivity ">
                                            <div className="d-flex gap-1 justify-content-end align-items-center">
                                                <p className="heading za-clr-red fs-17">!</p>
                                                <p className="heading fs-10 za-clr-red">Connectivity Failed</p>
                                            </div>
    
                                        </div>
                                </div>
                                 : null} */}

                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'submitterinformation'} onChange={handleChangeAccordian('submitterinformation')}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <p className="heading">Submitter Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-half'>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Type<span className='req'>*</span></label>
                                            <div className={practiceValidationModal.TypeVal ? 'form-group input error' : 'input form-group '}>
                                                <SuperSearchList
                                                    type="client"
                                                    id='Type'
                                                    name='Type'
                                                    searchValue={mainSubmitterModal.Type}
                                                    data={Type}
                                                    onChange={handleSubmitterChange}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                    inputError={practiceValidationModal.TypeVal}
                                                />
                                                {practiceValidationModal.TypeVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Business Name<span className='req'>*</span></label>
                                            <div className={practiceValidationModal.BusinessNameval ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="BusinessName"
                                                    id="BusinessName"
                                                    autoComplete="off"
                                                    value={mainSubmitterModal.BusinessName}
                                                    onChange={handleSubmitterChange}
                                                    inputError={practiceValidationModal.BusinessNameval}
                                                />
                                                {practiceValidationModal.BusinessNameval}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >First Name</label>
                                            <input type="text"
                                                className='form-control'
                                                name="FirstName"
                                                id="FirstName"
                                                autoComplete="off"
                                                value={mainSubmitterModal.FirstName}
                                                onChange={handleSubmitterChange} />

                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Submitter ID<span className='req'>*</span></label>
                                            <div className={practiceValidationModal.SubmitterIDVal ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="SubmitterID"
                                                    id="SubmitterID"
                                                    autoComplete="off"
                                                    // onKeyPress={handleNumericCheck}
                                                    value={mainSubmitterModal.SubmitterID}
                                                    onChange={handleSubmitterChange} />
                                                {practiceValidationModal.SubmitterIDVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Contact Name<span className='req'>*</span></label>
                                            <div className={practiceValidationModal.ContactNameval ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="ContactName"
                                                    id="ContactName"
                                                    autoComplete="off"
                                                    value={mainSubmitterModal.ContactName}
                                                    onChange={handleSubmitterChange} />
                                                {practiceValidationModal.ContactNameval}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <div className='input'>
                                            <label >Phone Number<span className='req'>*</span> </label>
                                            <div className={practiceValidationModal.PhoneNumberVal || practiceValidationModal.PhoneNumberLenghtVal ? 'form-group input error' : 'form-group input'}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder="(555) 555-5555"
                                                    name="PhoneNumber"
                                                    id="PhoneNumber"
                                                    autoComplete="off"
                                                    value={mainSubmitterModal.PhoneNumber}
                                                    onChange={handleSubmitterChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {practiceValidationModal.PhoneNumberVal || practiceValidationModal.PhoneNumberLenghtVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='input'>
                                            <label >Email </label>
                                            <div className={practiceValidationModal.EmailVal ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="Email"
                                                    id="Email"
                                                    autoComplete="off"
                                                    value={mainSubmitterModal.Email}
                                                    onChange={handleSubmitterChange} />
                                                {practiceValidationModal.EmailVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            {/* // expanded={expanded === 'headerinformation'} onChange={handleChangeAccordian('headerinformation')}> */}
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <p className="heading">Header Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row header_information align-items-center hk-form-fields'>
                                    <div className="col-md-6 pe-0">
                                        <div className='input'>

                                            <div className="row  align-items-baseline m-0 g-0">
                                                <div className="col-md-6 pe-12">
                                                    <label >Authorization Info ISA01<span className='req'>*</span></label>
                                                    <div className={practiceValidationModal.ISA01ValReq ? 'input error' : 'input'}>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ISA01'
                                                            name='ISA01'
                                                            searchValue={mainSubmitterModal.ISA01}
                                                            data={ISA01}
                                                            onChange={handleSubmitterChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={practiceValidationModal.ISA01ValReq}
                                                        />
                                                        {practiceValidationModal.ISA01ValReq}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <label>and ISA02</label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="ISA02"
                                                        id="ISA02"
                                                        autoComplete="off"
                                                        maxLength={10}
                                                        value={mainSubmitterModal.ISA02}
                                                        onChange={handleSubmitterChange}
                                                    />
                                                    {/* {practiceValidationModal.ISA02ValReq} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <div className="row row-full  align-items-baseline m-0 g-0">
                                                <div className="col-md-6 pe-12">
                                                    <label >Password Info ISA03<span className='req'>*</span></label>
                                                    <div className={practiceValidationModal.ISA03ValReq ? 'input error' : 'input'}>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ISA03'
                                                            name='ISA03'
                                                            searchValue={mainSubmitterModal.ISA03}
                                                            data={ISA03}
                                                            onChange={handleSubmitterChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={practiceValidationModal.ISA03ValReq}
                                                        />
                                                        {practiceValidationModal.ISA03ValReq}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label>and ISA04</label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="ISA04"
                                                        id="ISA04"
                                                        autoComplete="off"
                                                        maxLength={10}
                                                        value={mainSubmitterModal.ISA04}
                                                        onChange={handleSubmitterChange} />
                                                    {/* {practiceValidationModal.ISA04ValReq}
                                                                {practiceValidationModal.ISA04Val} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2 pe-0">
                                        <div className='input'>
                                            <div className="row   align-items-baseline m-0 g-0">
                                                <div className="col-md-6 pe-12">
                                                    <label >Sender ID ISA05<span className='req'>*</span></label>
                                                    <div className={practiceValidationModal.ISA05ValReq ? 'input error' : 'input'}>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ISA05'
                                                            name='ISA05'
                                                            searchValue={mainSubmitterModal.ISA05}
                                                            data={ISA05}
                                                            onChange={handleSubmitterChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={practiceValidationModal.ISA05ValReq}
                                                        />
                                                        {practiceValidationModal.ISA05ValReq}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label>and ISA06<span className='req'>*</span></label>
                                                    <div className={practiceValidationModal.ISA06ValReq ? 'input error' : 'input'}>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="ISA06"
                                                            id="ISA06"
                                                            autoComplete="off"
                                                            // maxLength={15}
                                                            value={mainSubmitterModal.ISA06}
                                                            onChange={handleSubmitterChange} />

                                                        {practiceValidationModal.ISA06ValReq}
                                                        {/* {practiceValidationModal.ISA06Val} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='input'>
                                            <div className="row   align-items-baseline m-0 g-0">
                                                <div className="col-md-6 pe-12">
                                                    <label> Receiver ID ISA07<span className='req'>*</span></label>
                                                    <div className={practiceValidationModal.ISA07ValReq ? 'input error' : 'input'}>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ISA07'
                                                            name='ISA07'
                                                            searchValue={mainSubmitterModal.ISA07}
                                                            data={ISA07}
                                                            onChange={handleSubmitterChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={practiceValidationModal.ISA07ValReq}
                                                        />
                                                        {practiceValidationModal.ISA07ValReq}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label>and ISA08<span className='req'>*</span></label>
                                                    <div className={practiceValidationModal.ISA08ValReq ? 'input error' : 'input'}>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="ISA08"
                                                            id="ISA08"
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            value={mainSubmitterModal.ISA08}
                                                            onChange={handleSubmitterChange} />
                                                        {practiceValidationModal.ISA08ValReq}

                                                    </div>
                                                    {/* {practiceValidationModal.ISA08Val} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2 pe-0">
                                        <div className='input'>
                                            <div className="row  align-items-center m-0 g-0">
                                                <div className="col-md-6 pe-12">
                                                    <div className={practiceValidationModal.ISA15ValReq ? 'input error' : 'input'}>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ISA15'
                                                            name='ISA15'
                                                            searchValue={mainSubmitterModal.ISA15}
                                                            data={ISA15}
                                                            onChange={handleSubmitterChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={practiceValidationModal.ISA15ValReq}

                                                        />
                                                        {practiceValidationModal.ISA15ValReq}

                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className={practiceValidationModal.ISA15ValReq ? 'input error' : 'input'}>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <label>Test/Prod Indicator ISA15</label><span className='req'>*</span>
                                                        </div>
                                                        {practiceValidationModal.ISA15ValReq}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <div className='row  m-0 g-0'>
                                            <div className="col-6 pe-12">
                                                <div className={practiceValidationModal.GS02ValReq ? 'input error' : 'input'}>
                                                    <label >Sender ID GS02<span className='req'>*</span></label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="GS02"
                                                        id="GS02"
                                                        autoComplete="off"
                                                        maxLength={15}
                                                        value={mainSubmitterModal.GS02}
                                                        onChange={handleSubmitterChange} />
                                                    {practiceValidationModal.GS02ValReq}
                                                    {/* {practiceValidationModal.GS02Val} */}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className={practiceValidationModal.GS03ValReq ? 'input error' : 'input'}>
                                                    <label >Receiver ID GS03<span className='req'>*</span></label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="GS03"
                                                        id="GS03"
                                                        autoComplete="off"
                                                        maxLength={15}
                                                        value={mainSubmitterModal.GS03}
                                                        onChange={handleSubmitterChange} />
                                                    {practiceValidationModal.GS03ValReq}
                                                    {/* {practiceValidationModal.GS03Val} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-5 acknowledge custom_check_box hk-checkbox mt-2">
                                        <div className='input align-items-center'>
                                            <label className="d-flex gap-6 align-items-center">
                                                <input type="checkbox" className='form-check-input m-0 p-0'
                                                    id="AcknowledgeRequested"
                                                    name="AcknowledgeRequested"
                                                    autoComplete="off"
                                                    checked={mainSubmitterModal.AcknowledgeRequested}
                                                    onChange={handleSubmitterChange} />
                                                Acknowledge Requested
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    <div className="pb-15">
                        {AddNewSubmitterModalBody()}
                    </div>
                    <ModalFooter isSaved={onSubmitterSave ? onDeleteSubmitter : onClose} handleSave={handleSaveSubmitter} UpdatedDate={mainSubmitterModal.UpdatedDate} UpdatedBy={mainSubmitterModal.UpdatedBy} ID={SubmitterID} IsEditAllowed={IsEditAllowed} />
                </div>
                :
                <Modal show={IsOpenSubmitter} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 hk-dropdown-menu add_new-submitter-popup">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetSubmitterName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onSubmitterSave ? onDeleteSubmitter : onClose} key={624} Name={'Submitter'} IsDeleteAllowed={IsDeleteAllowed} />
                        {isLoading ? <Loader /> : null}
                        {AddNewSubmitterModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onSubmitterSave ? onDeleteSubmitter : onClose} handleSave={handleSaveSubmitter} UpdatedDate={mainSubmitterModal.UpdatedDate} UpdatedBy={mainSubmitterModal.UpdatedBy} ID={SubmitterID} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }
        </React.Fragment>

    )
}

export default AddNewSubmitter